import { MapPin, Video } from "lucide-react";

export function LocationBadge({ kind, name }) {
  const map = {
    flagship: { bg: "bg-[#144F75]/10", text: "text-[#144F75]", label: name || "EYW Flagship" },
    affiliate: { bg: "bg-[#D98E73]/15", text: "text-[#B5794E]", label: name || "Affiliate" },
    virtual: { bg: "bg-[#8FA89B]/15", text: "text-[#5B8A72]", label: name || "Virtual" },
  };
  const s = map[kind] || map.affiliate;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${s.bg} ${s.text}`}>
      {kind === "virtual" ? <Video size={11} /> : <MapPin size={11} />}{s.label}
    </span>
  );
}
